import {
  GetPreferencesForAddressInstructionsQuery,
  GetPreferencesForAddressInstructionsQueryVariables
} from '@data/__generated__/types.main'
import useForcedAddress from '@page-components/Order/Products/useForcedAddress'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import useWebsiteId from './useWebsiteId'

export default function useWebsiteAddressInstructionModal() {
  const websiteId = useWebsiteId()
  const canUseInstructionModal = useForcedAddress()

  const {data} = useQuery<
    GetPreferencesForAddressInstructionsQuery,
    GetPreferencesForAddressInstructionsQueryVariables
  >({
    query: gql`
      query getPreferencesForAddressInstructions($websiteId: ID) {
        website(websiteId: $websiteId) {
          _id
          shouldUseInitialAddressMode
        }
      }
    `,
    variables: {websiteId},
    fetchPolicy: 'cache-first',
    omit: !websiteId || !canUseInstructionModal
  })

  if (!canUseInstructionModal) return false

  return !!data?.website?.shouldUseInitialAddressMode
}
